import Message from 'owa-service/lib/contract/Message';
import { action } from 'satcheljs';
import { ActionSource } from 'owa-mail-store';
import { BrandSubscriptionModel } from 'owa-brands-subscription';
import { ItemViewState } from 'owa-mail-reading-pane-store';

/**
 * Show the unsubscribe confirmation dialog
 * @param message the message
 * @param cacheEntry the Subscription Cache entry which is to be unsubscribed
 * @param actionSource the user source that initated the action
 * @param itemViewState the param required to remove the infobar from RP once unsubscribe is completed successfully
 */

export default action(
    'unsubscribeEmailV2',
    (
        message: Message,
        cacheEntry: BrandSubscriptionModel,
        actionSource: ActionSource,
        itemViewState: ItemViewState
    ) => ({
        message: message,
        cacheEntry: cacheEntry,
        actionSource: actionSource,
        itemViewState: itemViewState,
    })
);
